// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"0afac849","621":"e166569e","743":"fe3cd4f5"}[chunkId] + ".chunk.js";
};